
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType, blobDownload, formatDateTimeSeconds } from '../../../../util';
import { initClient } from '../../../../api';
import { InventoryUiClient } from '../../../backend/backendapi';
import { FileStatusMessage, StatusMessage } from "../../../dropzone/dropzone.util";
import DropZone from '../../../dropzone/DropZone';


declare var window: WindowType;

@Component({
  name: 'InventoryImportModal',
  components: {
    DropZone,
  }
})
export default class InventoryImportModal extends Vue {
  //api
  private readonly service = initClient(InventoryUiClient);


  private get dropzoneUrl(): string {
    return window.application.baseUrl + 'api/v1/inventory/import';
  }

  private get pivotUrl(): string {
    return window.application.baseUrl + 'pivot';
  }

  private get uid(): string {
    return (this as any)._uid;
    }

  private onUploaded(status: FileStatusMessage): void {
    console.log("uploaded");
      if (status.type == StatusMessage.information) {
          this.dismiss()
          this.$emit('imported');
          return;
      } else if (status.type !== StatusMessage.success) {
          this.$toasted.error(this.$t('txtError').toString());
          return;
      }
   this.service.getPickfile(status.fileId)
     .then(_ => {
       blobDownload(_.data, ( 'picklist' + '_' + formatDateTimeSeconds(new Date()) + '.xlsx'));
       this.$toasted.info(this.$t('txtDone').toString());
     })
    .catch( e=>  this.$toasted.error(this.$t('txtError').toString() ));
    this.dismiss()
}

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
